// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d_kos_dashboard {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Header ── */
.d_kos_header {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.d_kos_title {
  font-size: 22px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.d_kos_subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

/* ── Stat Cards ── */
.d_kos_stats-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.d_kos_stat-card {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.d_kos_stat-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d_kos_stat-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.d_kos_stat-icon {
  width: 18px;
  height: 18px;
  color: #6b6b6b;
}

.d_kos_stat-label {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

.d_kos_stat-value {
  font-size: 28px;
  font-weight: 700;
  color: #0b0b0b;
  margin: 0;
}

.d_kos_stat-alert {
  color: #e90000;
}

.d_kos_stat-meta {
  font-size: 13px;
  color: #949494;
  margin: 0;
}

.d_kos_stat-progress-wrap {
  height: 6px;
  background: #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}

.d_kos_stat-progress-bar {
  height: 100%;
  background: #eba85a;
  border-radius: 4px;
}

/* ── Main Section ── */
.d_kos_main-section {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 16px;
  align-items: start;
}

/* ── Prep Panel ── */
.d_kos_prep-panel,
.d_kos_alert-panel {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 20px;
}

.d_kos_panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}

.d_kos_panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 4px 0;
}

.d_kos_panel-subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

.d_kos_ai-badge {
  font-size: 13px;
  font-weight: 500;
  background: #d9f2ff;
  color: #0860e6;
  padding: 3px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

.d_kos_prep-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.d_kos_prep-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fafafa;
}

.d_kos_prep-accent {
  width: 4px;
  height: 36px;
  border-radius: 4px;
  flex-shrink: 0;
}

.d_kos_urgency-asap {
  background: #e90000;
}

.d_kos_urgency-soon {
  background: #eba85a;
}

.d_kos_urgency-later {
  background: #219647;
}

.d_kos_prep-info {
  flex: 1;
  min-width: 0;
}

.d_kos_prep-name {
  font-size: 14px;
  font-weight: 600;
  color: #0b0b0b;
  margin: 0 0 2px 0;
}

.d_kos_prep-meta {
  font-size: 13px;
  color: #6b6b6b;
  margin: 0;
}

.d_kos_prep-urgency {
  font-size: 13px;
  color: #6b6b6b;
  white-space: nowrap;
}

.d_kos_prep-btn {
  padding: 6px 14px;
  background: #0860e6;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.d_kos_prep-btn:hover {
  background: #2a71ff;
}

/* ── Alert Panel ── */
.d_kos_alert-panel .d_kos_panel-title {
  margin-bottom: 16px;
}

.d_kos_alert-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.d_kos_alert-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.d_kos_alert-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.d_kos_alert-name {
  font-size: 13px;
  color: #0b0b0b;
  margin: 0;
}

.d_kos_alert-percent {
  font-size: 13px;
  font-weight: 600;
  color: #6b6b6b;
  margin: 0;
}

.d_kos_alert-critical {
  color: #e90000;
}

.d_kos_alert-bar-bg {
  height: 6px;
  background: #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}

.d_kos_alert-bar-fill {
  height: 100%;
  border-radius: 4px;
}

.d_kos_alert-bar-critical {
  background: #e90000;
}

.d_kos_alert-bar-warning {
  background: #eba85a;
}

.d_kos_alert-bar-ok {
  background: #219647;
}

.d_kos_view-all-btn {
  margin-top: 16px;
  width: 100%;
  padding: 8px;
  background: transparent;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  font-size: 13px;
  color: #6b6b6b;
  cursor: pointer;
}

.d_kos_view-all-btn:hover {
  background: #f5f5f5;
  color: #0b0b0b;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Kitchen-OS/components/dashboard-kitchenOS.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".d_kos_dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ── Header ── */\n.d_kos_header {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.d_kos_title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.d_kos_subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n/* ── Stat Cards ── */\n.d_kos_stats-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n}\n\n.d_kos_stat-card {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.d_kos_stat-card-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.d_kos_stat-icon-wrap {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.d_kos_stat-icon {\n  width: 18px;\n  height: 18px;\n  color: #6b6b6b;\n}\n\n.d_kos_stat-label {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.d_kos_stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.d_kos_stat-alert {\n  color: #e90000;\n}\n\n.d_kos_stat-meta {\n  font-size: 13px;\n  color: #949494;\n  margin: 0;\n}\n\n.d_kos_stat-progress-wrap {\n  height: 6px;\n  background: #e6e6e6;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.d_kos_stat-progress-bar {\n  height: 100%;\n  background: #eba85a;\n  border-radius: 4px;\n}\n\n/* ── Main Section ── */\n.d_kos_main-section {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 16px;\n  align-items: start;\n}\n\n/* ── Prep Panel ── */\n.d_kos_prep-panel,\n.d_kos_alert-panel {\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.d_kos_panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 16px;\n}\n\n.d_kos_panel-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 4px 0;\n}\n\n.d_kos_panel-subtitle {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.d_kos_ai-badge {\n  font-size: 13px;\n  font-weight: 500;\n  background: #d9f2ff;\n  color: #0860e6;\n  padding: 3px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.d_kos_prep-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.d_kos_prep-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  background: #fafafa;\n}\n\n.d_kos_prep-accent {\n  width: 4px;\n  height: 36px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.d_kos_urgency-asap {\n  background: #e90000;\n}\n\n.d_kos_urgency-soon {\n  background: #eba85a;\n}\n\n.d_kos_urgency-later {\n  background: #219647;\n}\n\n.d_kos_prep-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.d_kos_prep-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0b0b0b;\n  margin: 0 0 2px 0;\n}\n\n.d_kos_prep-meta {\n  font-size: 13px;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.d_kos_prep-urgency {\n  font-size: 13px;\n  color: #6b6b6b;\n  white-space: nowrap;\n}\n\n.d_kos_prep-btn {\n  padding: 6px 14px;\n  background: #0860e6;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.d_kos_prep-btn:hover {\n  background: #2a71ff;\n}\n\n/* ── Alert Panel ── */\n.d_kos_alert-panel .d_kos_panel-title {\n  margin-bottom: 16px;\n}\n\n.d_kos_alert-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.d_kos_alert-item {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.d_kos_alert-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.d_kos_alert-name {\n  font-size: 13px;\n  color: #0b0b0b;\n  margin: 0;\n}\n\n.d_kos_alert-percent {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b6b6b;\n  margin: 0;\n}\n\n.d_kos_alert-critical {\n  color: #e90000;\n}\n\n.d_kos_alert-bar-bg {\n  height: 6px;\n  background: #e6e6e6;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.d_kos_alert-bar-fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.d_kos_alert-bar-critical {\n  background: #e90000;\n}\n\n.d_kos_alert-bar-warning {\n  background: #eba85a;\n}\n\n.d_kos_alert-bar-ok {\n  background: #219647;\n}\n\n.d_kos_view-all-btn {\n  margin-top: 16px;\n  width: 100%;\n  padding: 8px;\n  background: transparent;\n  border: 1px solid #e6e6e6;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #6b6b6b;\n  cursor: pointer;\n}\n\n.d_kos_view-all-btn:hover {\n  background: #f5f5f5;\n  color: #0b0b0b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
